import axios from "axios";

export default {
    namespaced: true,

    state: {},

    mutations: {},

    actions: {
        find({ commit }, id) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/medico/charting_by_exceptions/${id}`)
                    .then((res) => {
                        resolve(res.data.data.chartingByException);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },

        create({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post("/medico/charting_by_exceptions", data)
                    .then((res) => {
                        resolve(res.data.data.chartingByException);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },

        update({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .put(`/medico/charting_by_exceptions/${data.id}`, data)
                    .then((res) => {
                        resolve(res.data.data.chartingByException);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },

        delete({ commit }, id) {
            return new Promise((resolve, reject) => {
                axios
                    .delete(`/medico/charting_by_exceptions/${id}`)
                    .then((res) => {
                        resolve(res);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },

        restore({ commit }, id) {
            return new Promise((resolve, reject) => {
                axios
                    .put(
                        `/medico/charting_by_exceptions/${id}/restore`
                    )
                    .then((res) => {
                        resolve(res);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },

        buildForm(_, id) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/medico/charting_by_exceptions/form/${id}`)
                    .then((res) => {
                        resolve(res.data.data.form);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },

        getAnswers(_, id) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/medico/charting_by_exceptions/${id}/values`)
                    .then((res) => {
                        resolve(res.data.data.values);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },

        getExceptions(_, id) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/medico/charting_by_exceptions/${id}/items`)
                    .then((res) => {
                        resolve(res.data.data.exceptions);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },
    },
};
